export type ShopLinkType = 'voucher' | 'snack-shop' | 'login';

export const SHOP_LINK_TYPES: ShopLinkType[] = ['voucher', 'snack-shop', 'login'];

export type ShopLink = {
    type: ShopLinkType;
    url?: string;
    useEmbedded?: boolean;
    customName?: string;
};
